/**
 * Validates a notification-hotkey combo string entered in the Special Events editor.
 * Mirrors the client app's parser (buff.app parseHotkeyString) so anything accepted here actually
 * binds in-game: optional modifiers (Ctrl/Control, Alt, Shift, case-insensitive) plus exactly one
 * main key — a letter A-Z, a digit 0-9, or a function key F1-F12 — joined with "+".
 *
 * Examples: "Ctrl+Shift+O", "Alt+Shift+B", "Ctrl+O", "F7".
 */
const MODIFIERS = new Set(["ctrl", "control", "alt", "shift"])

const isValidKeyToken = (token: string): boolean => /^[A-Za-z0-9]$/.test(token) || /^[Ff]([1-9]|1[0-2])$/.test(token)

export const isValidHotkeyCombo = (value: string): boolean => {
  const tokens = value.split("+").map(token => token.trim()).filter(Boolean)
  if (tokens.length === 0) return false

  let keyCount = 0
  for (const token of tokens) {
    if (MODIFIERS.has(token.toLowerCase())) continue
    if (!isValidKeyToken(token)) return false
    keyCount += 1
  }

  return keyCount === 1
}

export const HOTKEY_VALIDATION_MESSAGE
  = "Use Ctrl/Alt/Shift + one key (A-Z, 0-9, or F1-F12), e.g. Ctrl+Shift+O"
